/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ToggleLocationBrandEnabledRequest
 */
export interface ToggleLocationBrandEnabledRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleLocationBrandEnabledRequest
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the ToggleLocationBrandEnabledRequest interface.
 */
export function instanceOfToggleLocationBrandEnabledRequest(value: object): value is ToggleLocationBrandEnabledRequest {
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function ToggleLocationBrandEnabledRequestFromJSON(json: any): ToggleLocationBrandEnabledRequest {
    return ToggleLocationBrandEnabledRequestFromJSONTyped(json, false);
}

export function ToggleLocationBrandEnabledRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ToggleLocationBrandEnabledRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function ToggleLocationBrandEnabledRequestToJSON(json: any): ToggleLocationBrandEnabledRequest {
    return ToggleLocationBrandEnabledRequestToJSONTyped(json, false);
}

export function ToggleLocationBrandEnabledRequestToJSONTyped(value?: ToggleLocationBrandEnabledRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enabled': value['enabled'],
    };
}

